import { c as _c } from "react/compiler-runtime";
import { getEntitiesByFpIdDupesOptions } from '@onefootprint/fetch-dashboard';
import type { DupeKind } from '@onefootprint/request-types/dashboard';
import { useQuery } from '@tanstack/react-query';
import { SETTLED_ONBOARDING_CACHE } from '@/entity/constants';

/** A timestamp is a finished onboarding's completedAt, so the dupes it pins take that onboarding's cache times. */
const getEntityDuplicateDataOptions = (id: string, timestamp?: string, kinds: DupeKind[] = []) => ({
  ...getEntitiesByFpIdDupesOptions({
    path: {
      fpId: id
    },
    query: {
      timestamp,
      kinds: kinds.length > 0 ? kinds.join(',') : undefined
    }
  }),
  ...(timestamp ? SETTLED_ONBOARDING_CACHE : undefined)
});
const useEntityDuplicateData = (id, timestamp, t0, t1) => {
  const $ = _c(9);
  const enabled = t0 === undefined ? true : t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const kinds = t2;
  let t3;
  if ($[2] !== id || $[3] !== kinds || $[4] !== timestamp) {
    t3 = getEntityDuplicateDataOptions(id, timestamp, kinds);
    $[2] = id;
    $[3] = kinds;
    $[4] = timestamp;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = !!id && enabled;
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = {
      ...t3,
      enabled: t4
    };
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return useQuery(t5);
};
export { getEntityDuplicateDataOptions };
export default useEntityDuplicateData;